export const AGENTS_LIST = [
    { label: 'All Agents', value: 'all_agents' },
    // { label: 'Accounting Agent', value: 'accounting_agent' },
    { label: 'Receptionist', value: 'receptionist' },
    { label: 'Cashier', value: 'cashier_agent' },
    { label: 'Guest Intelligence', value: 'guest_intelligence' },
    { label: 'Reservation Agent', value: 'reservation_agent' },
    { label: 'Account Receivable Agent', value: 'account_receivable_agent' },
    { label: 'Account Payable Agent', value: 'account_payable_agent' },
]